const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNaranjaX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.01,12.35v-6.7s.04-.09.09-.09h.93s.05.01.07.03l3.4,4.53c.05.07.15.03.15-.05v-4.43s.04-.09.09-.09h1.04s.09.04.09.09v6.7s-.04.09-.09.09h-.92s-.05-.01-.07-.03l-3.4-4.53c-.05-.07-.15-.03-.15.05v4.43s-.04.09-.09.09h-1.05s-.09-.04-.09-.09Z",
    style: {
      fill: "#fe5000"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.71,8.82l-2.04-3.16c-.04-.06-.1-.09-.17-.09h-1.36s-.07.03-.07.07c0,.01,0,.02.01.03l2.12,3.3s.01.05,0,.07l-2.12,3.29s-.01.07.02.09c.01,0,.02.01.04.01h1.36c.07,0,.13-.03.17-.09l2.04-3.15c.07-.11.07-.26,0-.37h0Z",
    style: {
      fill: "#fe5000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.13,9.46s-.06-.04-.09-.02c0,0-.01.01-.02.02l-.56.87c-.11.17-.11.39,0,.55l.95,1.47s.09.08.14.08h1.41s.05-.02.05-.05c0,0,0-.02,0-.03l-1.87-2.89Z",
    style: {
      fill: "#50007f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.02,8.53s.06.04.09.02c0,0,.01-.01.02-.02l1.87-2.89s0-.06-.02-.07c0,0-.02,0-.03,0h-1.41c-.06,0-.11.03-.14.08l-.95,1.47c-.11.17-.11.39,0,.55l.56.86Z",
    style: {
      fill: "#50007f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaranjaX);
export default __webpack_public_path__ + "static/media/naranja-x.f00fc97bfed0488c4b3beec367e19516.svg";
export { ForwardRef as ReactComponent };